import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import Nav from "@/sections/Nav";
import Hero from "@/sections/Hero";
import MarqueeStrip from "@/sections/MarqueeStrip";
import Manifesto from "@/sections/Manifesto";
import Services from "@/sections/Services";
import Portfolio from "@/sections/Portfolio";
import Booking from "@/sections/Booking";
import Footer from "@/sections/Footer";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App grain" data-testid="app-root">
        <Nav />
        <main>
          <Hero />
          <MarqueeStrip />
          <Manifesto />
          <Services />
          <Portfolio />
          <Booking />
        </main>
        <Footer />
        <Toaster theme="dark" position="bottom-right" richColors />
      </div>
    </ReactLenis>
  );
}

export default App;
